import { h, render, cloneElement, Component } from 'preact';
import Nav from './Nav';
class Template extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: false
        };
        this.setNavClass = this.setNavClass.bind(this);
    }
    setNavClass() {
        console.log('CLIKKKK');
        this.setState({
            isActive: !this.state.isActive
        });
    }
    render() {
        const props = this.props;
        const { isActive } = this.state;
        const menuClass = isActive ? "nav--active" : "";
        return h("div", { className: "container-fluid" },
            h("div", { className: "row" },
                h("div", { className: "nav__container" },
                    h("button", { className: "hamburger clearfix", onClick: this.setNavClass },
                        h("div", { className: "right" },
                            h("div", { className: "hamburger__line" }),
                            h("div", { className: "hamburger__line" }),
                            h("div", { className: "hamburger__line" }))),
                    h(Nav, { className: menuClass, username: props.auth.user.username, user: props.auth.user })),
                h("main", { className: "main-content" }, props.children.map(child => cloneElement(child, props)))));
    }
}
export default Template;
